import { render, staticRenderFns } from "./centerTitle.vue?vue&type=template&id=b708b33e&scoped=true&"
import script from "./centerTitle.vue?vue&type=script&lang=js&"
export * from "./centerTitle.vue?vue&type=script&lang=js&"
import style0 from "./centerTitle.vue?vue&type=style&index=0&id=b708b33e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b708b33e",
  null
  
)

export default component.exports